import React, { useState, useEffect, useRef } from "react";
import "./LanguageSwitcher.css";
import i18n from "../../../i18n";

const LanguageSwitcher = () => {
  const [showPip, setShowPip] = useState(true);
  const [showEdgePanel, setShowEdgePanel] = useState(false);
  const [selectedLang, setSelectedLang] = useState(i18n.language || "en");
  const pipRef = useRef(null);
  const timeoutRef = useRef(null);

  // Sync with i18n on mount
  useEffect(() => {
    const currentLang = i18n.language;
    if (currentLang !== selectedLang) {
      setSelectedLang(currentLang);
    }
  }, []);

  const startAutoHideTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    timeoutRef.current = setTimeout(() => {
      setShowPip(false);
      setShowEdgePanel(true);
    }, 4000);
  };

  useEffect(() => {
    startAutoHideTimer();

    const handleClickOutside = (event) => {
      if (pipRef.current && !pipRef.current.contains(event.target)) {
        setShowPip(false);
        setShowEdgePanel(true);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Update selectedLang when i18n.language changes
  useEffect(() => {
    setSelectedLang(i18n.language);
  }, [i18n.language]);

  const handleEdgePanelClick = (e) => {
    e.stopPropagation();
    setShowPip(true);
    setShowEdgePanel(false);
    startAutoHideTimer();
  };

  const changeLanguage = async () => {
    const newLang = selectedLang === "en" ? "ja" : "en";
    try {
      await i18n.changeLanguage(newLang);
      setSelectedLang(newLang);
      localStorage.setItem("language", newLang);
      startAutoHideTimer();
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  return (
    <>
      {showPip && (
        <div ref={pipRef} className="language-switcher-pip">
          <div className="language-switcher-content">
            <div className="language-icon">🌐</div>
            <div className="language-buttons">
              <div 
                className={`slider-highlight ${
                  selectedLang === "ja" ? "slider-right" : ""
                }`} 
              />
              <button
                className={`lang-button ${selectedLang === "en" ? "active" : ""}`}
                onClick={changeLanguage}
              >
                EN
              </button>
              <button
                className={`lang-button ${selectedLang === "ja" ? "active" : ""}`}
                onClick={changeLanguage}
              >
                JA
              </button>
            </div>
          </div>
        </div>
      )}

      {showEdgePanel && (
        <button
          className="edge-panel"
          onClick={handleEdgePanelClick}
        >
          🌐
        </button>
      )}
    </>
  );
};

export default LanguageSwitcher;